<template>
    <v-dialog v-model="dialogVisible" persistent max-width="900px">
      <v-card class="v-card-100">
        <div class="faq-topbar"></div>
        <v-card-title class="text-center pt-0">
          <span class="headline">FAQ</span>
          <v-icon @click="closeDialog" class="float-right" style="cursor: pointer; background-color: grey; border-radius: 50%;" size="30">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pt-0">
         <div class="faq-wrapper">
            <p class="text-center text-grey mb-10">
              Here are some of the Roomsy frequently asked questions
            </p>

            <v-row>
              <v-col cols="12" md="6" v-for="(faq, index) in faqs" :key="faq.id">
                <div class="faq-item">
                  <!-- Icon  -->
                  <div class="faq-icon">
                    <v-icon size="36" color="primary">mdi-bullseye-arrow</v-icon>
                  </div>
                  <div v-if="index < faqs.length - 2" class="icon-divider"></div>

                  <!-- Content -->
                  <div class="faq-content">
                    <h4 class="faq-title">{{ faq.title }}</h4>
                    <p class="faq-text">{{ faq.preview }}</p>
                    <v-btn variant="text" color="primary" class="pa-0" @click="openFaq(faq)">
                      Read More
                    </v-btn>
                  </div>
                </div>

                <!-- Extension line -->
                <div
                  v-if="index < faqs.length - 1"
                  class="faq-line"
                ></div>
              </v-col>
            </v-row>

            <FaqDialog ref="faqDialog" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script setup>
 import { ref, defineExpose } from 'vue';

 const dialogVisible = ref(false)
 const closeDialog = () => {
   dialogVisible.value = false
 }
 function open() {
  dialogVisible.value = true;
}

const faqs = [
  {
    id: 1,
    title: "How To Add A Booking Source",
    preview:
      "A Booking Source allows you to track which source provided the reservation...",
    content:
      "A Booking Source allows you to track which source provided the reservation. This data can be used to identify which sources are the best-performing ones for your hotel..."
  },
  {
    id: 2,
    title: "Rate Plan Settings",
    preview:
      "Rate plans must be setup in order to setup Online Booking Engine...",
    content:
      "Rate plans must be setup in order to setup Online Booking Engine, or connection to OTA’s (e.g. Booking.com). With rate plans setup, you won’t have to train your staff..."
  },
  {
    id: 3,
    title: "How To Move Rooms For Checked In Guests",
    preview:
      "Room Move for Inhouse Guests. Sometimes you have to move guests for a reason...",
    content:
      "Room Move for Inhouse Guests. Sometimes you have to move guests for a reason. This could be for operational issue or the guest may have asked for an upgrade..."
  },
  {
    id: 4,
    title: "How To Make Reservations For An Existing Group",
    preview:
      "Once you have found the group you are looking to make the reservation for...",
    content:
      "Once you have found the group you are looking to make the reservation for, using the Group Search function or by clicking on any reservation..."
  }
];
 // expose so parent can call open()
 defineExpose({ open });
</script>
<style scoped>
.faq-wrapper {
  max-width: 1000px;
  margin: auto;
}

.faq-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  position: relative;
}

.faq-icon {
  margin-right: 12px;
  margin-top: 5px;
}

.faq-title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 6px;
}

.faq-text {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.faq-line {
  height: 1px;
  background-color: #eee;
  margin: 20px 0;
}
.icon-divider{   
  height: 120px;
  background-color: red;
  width: 2px;
  position: relative;
  left: -30px;
  top: 46px;
}
.faq-topbar {
  height: 20px;
  margin-left:25%;
  background: #ccccff; /* light blue */
  clip-path: polygon(0 0, 100% 0, 100% 100%, 5% 100%);

}

</style>